import React from 'react';
import i18n from './shared/translations';

// providers
import {I18nextProvider} from 'react-i18next';
import {CssVarsProvider} from '@mui/joy';
import {ThemeProvider} from '@emotion/react';

// helpers
import {
  generateCustomEmotionTheme,
  generateCustomJoyUITheme,
} from './shared/theme';

import {ConfigManager} from './shared/services/ConfigManager';
import {AppBackground} from './shared/components/AppBackground';

interface AppProvidersProps {
  children: React.ReactNode;
}

/**
 * Contains all the providers needed for the application.
 */
function AppProviders({children}: AppProvidersProps) {
  const portalConfig = ConfigManager.getConfig();

  return (
    <I18nextProvider i18n={i18n}>
      <CssVarsProvider theme={generateCustomJoyUITheme(portalConfig)}>
        <ThemeProvider theme={generateCustomEmotionTheme(portalConfig)}>
          <AppBackground>{children}</AppBackground>
        </ThemeProvider>
      </CssVarsProvider>
    </I18nextProvider>
  );
}

export default AppProviders;
